module.exports = {
  VIEW_PATH: 'view',
  ADMIN_PATH: 'admin',
  EDITOR_PATH: 'editor',
  API_PATH: 'api',
  EDITOR_TITLE: '编辑器 - Automan 平台',
  ADMIN_TITLE: '管理后台 - Automan 平台'
}
